import type { ApolloError } from "@apollo/client";

export default function getApolloErrorMessages(error: ApolloError) {
  if (error.graphQLErrors?.length) {
    return error.graphQLErrors.map((e) => e.message);
  }
  return [error.message];
}
